import { ToastProvider } from "./components/ui";
import { AdminApp } from "./pages/AdminApp";
import { PublicHome } from "./pages/PublicHome";

export function App() {
  const isAdmin = window.location.pathname.startsWith("/admin");
  return <ToastProvider>{isAdmin ? <AdminApp /> : <PublicHome />}</ToastProvider>;
}
